<template>
  <el-container class="app-shell">
    <el-aside width="220px" class="sidebar">
      <div class="logo">
        <div class="logo-icon">L</div>
        <div>
          <strong>轻奢记账</strong>
          <small>Luxury Ledger</small>
        </div>
      </div>
      <el-menu :default-active="$route.path" router background-color="#18181b" text-color="#d4d4d8" active-text-color="#ffffff">
        <el-menu-item index="/dashboard"><i class="el-icon-data-analysis"></i><span>首页看板</span></el-menu-item>
        <el-menu-item index="/items"><i class="el-icon-tickets"></i><span>商品记录</span></el-menu-item>
        <el-menu-item index="/reconciliation"><i class="el-icon-s-finance"></i><span>对账统计</span></el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="topbar">
        <div>
          <h2>{{ pageTitle }}</h2>
          <span>{{ today }}</span>
        </div>
        <el-dropdown @command="onCommand">
          <span class="user-box">
            {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-main class="main"><router-view /></el-main>
    </el-container>
    <nav class="mobile-tabbar" aria-label="移动端主导航">
      <router-link
        v-for="item in navItems"
        :key="item.path"
        :to="item.path"
        class="mobile-tabbar-item"
        :class="{ active: isActive(item.path) }"
        :aria-label="item.label"
      >
        <i :class="item.icon"></i>
        <span>{{ item.label }}</span>
      </router-link>
    </nav>
  </el-container>
</template>

<script>
import dayjs from 'dayjs'
import { logout } from '@/api/auth'

export default {
  name: 'Layout',
  data() {
    return {
      navItems: [
        { path: '/dashboard', label: '首页', icon: 'el-icon-data-analysis' },
        { path: '/items', label: '商品', icon: 'el-icon-tickets' },
        { path: '/reconciliation', label: '对账', icon: 'el-icon-s-finance' }
      ]
    }
  },
  computed: {
    pageTitle() { return this.$route.meta.title || '轻奢鞋服记账工具' },
    userName() { return (this.$store.state.user && this.$store.state.user.nickname) || '管理员' },
    today() { return dayjs().format('YYYY年MM月DD日') }
  },
  methods: {
    async onCommand(command) {
      if (command === 'logout') {
        try { await logout() } catch (e) {}
        this.$store.commit('CLEAR_LOGIN')
        this.$router.replace('/login')
      }
    },
    isActive(path) {
      return this.$route.path === path
    }
  }
}
</script>

<style scoped>
.app-shell { min-height: 100vh; }
.sidebar { background: #18181b; color: #fff; }
.logo { height: 72px; display: flex; align-items: center; gap: 12px; padding: 0 18px; border-bottom: 1px solid rgba(255,255,255,.08); }
.logo-icon { width: 38px; height: 38px; border-radius: 12px; display: flex; align-items: center; justify-content: center; background: #2563eb; font-weight: 800; }
.logo strong { display: block; font-size: 16px; }
.logo small { display: block; margin-top: 3px; color: #a1a1aa; font-size: 12px; }
.sidebar /deep/ .el-menu { border-right: none; }
.topbar { height: 72px !important; background: #fff; border-bottom: 1px solid #e4e4e7; display: flex; align-items: center; justify-content: space-between; }
.topbar h2 { margin: 0 0 5px; font-size: 20px; }
.topbar span { color: #71717a; font-size: 13px; }
.user-box { display: inline-flex; align-items: center; cursor: pointer; color: #18181b !important; font-weight: 600; }
.main { background: #f6f7fb; padding: 22px; }
.mobile-tabbar { display: none; }
@media (max-width: 768px) {
  .app-shell { min-height: 100dvh; }
  .sidebar { display: none; }
  .topbar {
    height: 60px !important;
    padding: 0 14px !important;
    position: sticky;
    top: 0;
    z-index: 20;
  }
  .topbar h2 { font-size: 18px; margin-bottom: 2px; }
  .topbar span { font-size: 12px; }
  .user-box { min-height: 44px; padding-left: 8px; }
  .main { padding: 12px 12px 88px; }
  .mobile-tabbar {
    position: fixed;
    left: 10px;
    right: 10px;
    bottom: calc(8px + env(safe-area-inset-bottom));
    z-index: 1000;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    padding: 8px;
    border: 1px solid rgba(24,24,27,.08);
    border-radius: 18px;
    background: rgba(255,255,255,.96);
    box-shadow: 0 14px 34px rgba(15,23,42,.16);
    backdrop-filter: blur(12px);
  }
  .mobile-tabbar-item {
    min-height: 48px;
    border-radius: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    color: #71717a;
    text-decoration: none;
    font-size: 12px;
    font-weight: 600;
    transition: color .18s ease, background .18s ease, transform .18s ease;
    touch-action: manipulation;
  }
  .mobile-tabbar-item i { font-size: 20px; }
  .mobile-tabbar-item.active {
    color: #2563eb;
    background: #eff6ff;
  }
  .mobile-tabbar-item:active { transform: scale(.96); }
}
</style>
